/* istanbul ignore file */

import type { Environments } from "./global";

export function configuration() {
  window.memberPortalConfig = {
    baseApiUrl: `${window.location.origin}/api`,
    branchName: process.env.REACT_APP_BRANCH_NAME as string,
    bugsnagKey: process.env.REACT_APP_BUGSNAG_KEY as string,
    bugsnagReleaseStage: process.env.REACT_APP_ENV as string,
    environment: process.env.REACT_APP_ENV as Environments,
    muiLicense: process.env.REACT_APP_MUI_PRO_LICENSE as string,
    versionSha: process.env.REACT_APP_VERSION_SHA as string,
    cognitoConfig: {
      authority: process.env.REACT_APP_COGNITO_AUTHORITY as string,
      clientId: process.env.REACT_APP_COGNITO_CLIENT_ID as string,
      logoutRedirectUrl: `${window.location.origin}/logout`,
      redirectUrl: `${window.location.origin}/login/callback`,
      responseType: process.env.REACT_APP_COGNITO_RESPONSE_TYPE as string,
      scope: process.env.REACT_APP_COGNITO_SCOPE as string,
    },
  };
}
